import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Edit as EditIcon,
  Add as AddIcon,
  Delete as DeleteIcon
} from '@material-ui/icons'
import { Button } from '@material-ui/core'
import SweetAlert from 'sweetalert2-react'
import debounce from 'lodash.debounce'

import { product as productActions } from '../../actions'
import CustomTable from '../Table/CustomTable'

class Product extends Component {
  static propTypes = {
    count: PropTypes.func.isRequired,
    delete: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    fetch: PropTypes.func.isRequired,
    hideAlert: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
  }

  state = {
    page: 0,
    rowsPerPage: 10,
    fields: [
      {
        id: 'productImage',
        label: 'Image',
        type: 'image'
      },
      {
        id: 'productName',
        label: 'Name'
      },
      {
        id: 'productDescription',
        label: 'Description'
      },
    ],
  }
  componentDidMount() {
    this.props.count()
    this._getProduct()
  }
  _getProduct() {
    this.props.fetch(this.state.page, this.state.rowsPerPage)
  }
  handleChangePage = page => {
    let that = this
    this.setState({ page: page }, () => {
      that._getProduct()
    })
  }
  handleSearch = debounce(query => {
    this.props.count(query)
    this.props.fetch(this.state.page, this.state.rowsPerPage, query)
  }, 1000)
  handleChangeRowsPerPage = rowsPerPage => {
    let that = this
    this.setState({ rowsPerPage: rowsPerPage }, () => {
      that._getProduct()
    })
  }
  handleDeleteAction = id => {
    this.props.delete(id)
  }
  hideAlert() {
    this.props.hideAlert()
  }
  render() {
    const { errorMessage, total, history, list } = this.props
    return (
      <div>
        <div style={{ textAlign: 'right' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.props.history.push('/product/add')}
          >
            <AddIcon /> Add New
          </Button>
        </div>
        <CustomTable
          title={'Product'}
          total={total}
          history={history}
          tableHeaderColor="primary"
          tableHead={this.state.fields}
          page={this.state.page}
          rowsPerPage={this.state.rowsPerPage}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleSearch={this.handleSearch}
          handleDelete={this.handleDeleteAction}
          data={list}
          editPath="/product/edit/"
          actions={[
            {
              label: 'edit',
              icon: <EditIcon />,
              path: '/product/edit/',
              has_id: true,
              color: 'primary'
            },
            {
              label: 'delete',
              icon: <DeleteIcon />,
              has_id: true,
              color: 'secondary'
            }
          ]}
        />
        <SweetAlert
          type={errorMessage ? 'error' : 'success'}
          show={errorMessage ? true : false}
          title={errorMessage ? 'Error' : 'Notice'}
          text={errorMessage ? errorMessage : 'Deleted'}
          onConfirm={() => this.props.hideAlert()}
        />
      </div>
    )
  }
}


const mapStateToProps = state => ({
  total: state.product.total,
  list: state.product.list,
  deleted: state.product.deleted,
  errorMessage: state.product.errorMessage
})

const mapDispatchToProps = { ...productActions }



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Product)
